require('./ng-rollbar.js');
module.exports = 'tandibar/ng-rollbar';



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-rollbar/index.js
// module id = 663
// module chunks = 1